import { Icon, IconType, Modal } from "@cca/components";
import { PropsWithChildren } from "react";

export type NotificationModalProps = PropsWithChildren<{
  title?: string;
  iconType?: IconType;
  onClose(): void;
}>;

const NotificationModal = ({
  onClose,
  iconType = "award",
  title = "Congratulations!",
  children,
}: NotificationModalProps) => (
  <Modal onClose={onClose} position="center" show size="sm">
    <Modal.Header onClose={onClose} />
    <Modal.Body>
      <div className="bg-white px-6 py-8 text-center">
        <Icon className="text-blue-600" size="4x" type={iconType} />
        <h3
          className="mt-8 text-2xl leading-6 font-semibold text-gray-900 uppercase"
          id="modal-title"
        >
          {title}
        </h3>
        <div className="mt-6 mb-8">
          <p className="text-lg text-gray-500">{children}</p>
        </div>
      </div>
    </Modal.Body>
  </Modal>
);

export default NotificationModal;
